import { FormControl, FormLabel, Input, VStack, InputGroup, InputRightElement, Button, useToast } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import axios from "axios"
import { ChatState } from '../../context/ChatProvider'

const Login = () => {
  const [show, setShow] = useState(false)
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)

  const { setUser } = ChatState()

  const toast = useToast()
  const history = useHistory()

  const handleClick = () => setShow(!show)

  const submitHandler = async () => {
    setLoading(true)

    if (!email || !password) {
      toast({
        title: "Please Fill all the Feilds",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      })

      setLoading(false)
      return
    }

    try {
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      }

      const { data } = await axios.post(
        "/api/user/login",
        { email, password },
        config
      )

      toast({
        title: "Login Successful",
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      })

      localStorage.setItem("userInfo", JSON.stringify(data))
      setLoading(false)
      setUser(data)
      history.push("/chats")

    } catch (error) {
      toast({
        title: "Error Occured!",
        description: error.response.data.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      })

      setLoading(false)
    }
  };

  return (
    <VStack spacing='5px'>
      <FormControl id='email-login' isRequired>
        <FormLabel>
          Email
        </FormLabel>
        <Input
          placeholder='Your email'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </FormControl>
      <FormControl id='password-password' isRequired>
        <FormLabel>
          Password
        </FormLabel>
        <InputGroup size="md">
          <Input
            type={show ? "text":"password"}
            placeholder='Enter Password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />  
          <InputRightElement width="4.5rem">
            <Button h="1.75rem" size="sm" onClick={handleClick}>
              {show ? "Hide" : "Show"}
            </Button>
          </InputRightElement>
        </InputGroup>
      </FormControl>
      <Button
        colorScheme="blue"
        width="100%"
        style={{ marginTop: 15 }}
        onClick={submitHandler}
        isLoading={loading}
      >
        Log In
      </Button>
      
      <Button
        variant="solid"
        colorScheme="red"
        width="100%"
        onClick={() => {
          setEmail("guest@gupshup.com");
          setPassword("123456");
        }}
      >
        Login as Guest User
      </Button>
    </VStack>
  )
}

export default Login